// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-4e0144f2]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.right-tool-paging[data-v-4e0144f2] {\n  width: 100%;\n  padding: 0 20px;\n}\n.right-tool-paging[data-v-4e0144f2] .el-form-item {\n  margin: 0;\n}\n.right-tool-paging[data-v-4e0144f2] .el-form-item .el-form-item__label {\n  color: #8e8e8e;\n}", ""]);
// Exports
module.exports = exports;
